import { render, staticRenderFns } from "./Help_Center.vue?vue&type=template&id=30bb01da"
import script from "./Help_Center.vue?vue&type=script&lang=js"
export * from "./Help_Center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports